import React, { useEffect, useState } from 'react'
import { Layer, NoData } from 'components'
import styles from './index.module.css'
import { showTermsAgreeLayerState, showTermsAgreeDetailLayerState, showTermsAgreeDetailContentsLayerState } from 'views/setting/states'
import { useRecoilState, useSetRecoilState } from 'recoil'
import TermsAgreeDetailLayer from './TermsAgreeDetail'
import TermsAgreeDetailContentsLayer from './TermsAgreeDetailContents'
import Lib from 'library'


const TermsAgree = () => {

	const [showTermsAgreeLayer, setShowTermsAgreeLayer] = useRecoilState(showTermsAgreeLayerState)
	const [showTermsAgreeDetailLayer, setShowTermsAgreeDetailLayer] = useRecoilState(showTermsAgreeDetailLayerState)
	const setShowTermsAgreeDetailContentsLayer = useSetRecoilState(showTermsAgreeDetailContentsLayerState)

	const [termsEsntl, setTermsEsntl] = useState()
	const [termsOptnl, setTermsOptnl] = useState()
	const [termsNomal, setTermsNomal] = useState()
	const [termsOptnlDetail, setTermsOptnlDetail] = useState()
	const [termsEsntlDetail, setShowEsntlDetail] = useState()
	const [ctgry, setCtgry] = useState("Esntl")

	//약관/동의 리스트(데이터)가져오기
	const getData = () => {
		Lib.get("/api/more/etc/terms/mny", data => {
			setTermsEsntl(data.esntlTermsList)
			setTermsOptnl(data.nonEsntlTermsList)
			setTermsNomal(data.nomalTermsList)	//본인인증 동의
		})
	}

	useEffect(() => {
		getData()
		getData2()
	}, [showTermsAgreeLayer, showTermsAgreeDetailLayer])

	// 선택동의 상세보기(철회하기)
	const showOptnlLayer = (terms) => {
		setShowTermsAgreeDetailLayer(true)
		setTermsOptnlDetail(terms)
	}

	//필수동의 상세보기
	const showEsntlLayer = terms => {
		setShowEsntlDetail(terms)
		setShowTermsAgreeDetailContentsLayer(true)
	}

	const getData2 = () => {
		Lib.get("/api/more/etc/terms/mny", data => {
			console.log({data})
		})
	}

	return (
		<Layer show={showTermsAgreeLayer} closeLayer={() => setShowTermsAgreeLayer(false)}>
			<div className="page">
				<div className="shadow">
					<div className="padding">
						<div className={styles.title}>약관/동의</div>
						<p className={`${styles["t-title"]} mt_40`}>회원가입</p>
						<ul className={`${styles["link-menu"]} mt_30`}>
							{termsEsntl ?
								termsEsntl.map((item, index) => {
									return (
										<li key={item.termsCd} onClick={() => showEsntlLayer(item)}>
											<div className={styles.linkSpan}>
												<p>{item.termsNm}</p>
												<p className={styles.agree}>{Lib.dateFormat(item.agreeDe, ".")}<i className="icon icon_arrow_sm right ml_5" /></p>
											</div>
										</li>
									)
								})
								:
								<NoData text="데이터 조회중." />
							}
						</ul>
					</div>
				</div>
				{/* <div className="shadow">
					<div className="padding">
						<p className={styles["t-title"]}>본인인증 동의</p>
						<ul className={`${styles["link-menu"]} mt_30`}>
							{termsNomal ?
								termsNomal.map((item, index) => {
									return (
										<li key={item.termsCd} onClick={() => showEsntlLayer(item)}>
											<div className={styles.linkSpan}>
												<p>{item.termsNm}</p>
												<p className={styles.agree}>{Lib.dateFormat(item.agreeDe, ".")}<i className="icon icon_arrow_sm right ml_5" /></p>
											</div>
										</li>
									)
								})
								:
								<NoData text="데이터 조회중." />
							}
						</ul>
					</div>
				</div> */}
				{termsOptnl?.some(item => item.agreeYn === "Y") &&
					<div className="padding">
						<p className={styles["t-title"]}>서비스 동의</p>
						<ul className={`${styles["link-menu"]} mt_30`}>

							{termsOptnl ?
								termsOptnl.map((item, index) => {
									return (
										<li key={index}>
											{/* 서비스동의 -> 신용 외에 다른 항목 추가될 가능성 대비 */}
											{item.agreeYn === "Y" ?
												// <li key={index}>
												<div className={styles.linkSpan} onClick={() => showOptnlLayer(item)}>
													<p>{item.termsCtgryNm}</p>
													<p className={styles.agree}>{item.agreeYn === "Y" ? "동의" : "미동의"}({Lib.dateFormat(item.agreeDe, ".")})<i className="icon icon_arrow_sm right ml_5" /></p>
												</div>
												// </li>
												:
												null
											}
										</li>
									)
								})
								:
								<NoData text="데이터 조회중." />
							}
						</ul>
					</div>
				}
			</div>

			<TermsAgreeDetailContentsLayer termsEsntlDetail={termsEsntlDetail} ctgry={ctgry}/>
			<TermsAgreeDetailLayer termsOptnlDetail={termsOptnlDetail} />
		</Layer>
	)
}

export default TermsAgree
